import React from "react"
import { useSiteMetadata } from "../hooks/use-site-metadata";
import { StaticImage } from "gatsby-plugin-image";

function Invitation() {

  return (
    <>
        <section>
            <div className="container px-4 md:px-6">
                <h2>We cannot wait to welcome you to 5WCWS</h2>
                <div className="grid grid-cols-1 xl:grid-cols-2 gap-5">
                    <div className="border-b xl:border-b-0 xl:border-r border-neutral-300 pb-5 xl:pb-0 xl:pr-5 flex flex-col justify-between">
                        <div>
                            <p>It is my great honour to invite you to be part of the 5th World Conference of Women’s Shelters (5WCWS), 15-18 September 2025 in Sydney, Australia. It will be held for the first time in the southern hemisphere!</p>
                            <p>We expect 1,000+ delegates from 100+ countries to attend. Held 4 times previously, the World Conference is a unique international forum designed to advance the services for women’s shelters and end gender based violence.</p>
                            <p>5WCWS will provide a platform for networking, knowledge transfers, collaboration, and exploration on topical issues, resulting in ground-breaking best practices, new knowledge and innovation, and practical solutions.</p>
                            <p>We look forward to welcoming you to beautiful Sydney.</p>
                        </div>

                        <div className="flex items-center gap-5">
                            <StaticImage
                                src="../program-advisory/Julie-Oberin.jpg"
                                alt="Julie Oberin AM"
                                width={100}
                                layout="constrained"
                                placeholder="blurred"
                                formats={["auto", "webp"]}
                                className="flex-none"
                            />
                            <div>
                                <h4 className="mt-0">Julie Oberin AM</h4>
                                <span className="italic">5WCWS Conference Chair, Wesnet Board member and GNWS Founding member</span>
                            </div>
                        </div>
                    </div>

                    <div className="flex flex-col justify-between">
                        <div>
                            <p>The World Conference of Women’s Shelters is a premier platform with a legacy of facilitating meaningful international collaboration and making a global impact on women’s safety.</p>
                            <p>Showcasing 1,000+ delegates at 5WCWS, the program will look at developments around the world, celebrate the dynamism of our wonderfully diverse profession, and set our sights on the challenges of the future.</p>
                            <p>We look forward to inspiring our delegates to make 5WCWS an outstanding success.</p>
                        </div>
                        <div className="flex items-center gap-5">
                            <StaticImage
                                src="../program-advisory/Aleid-van-den-Brink.jpg"
                                alt="Julie Oberin AM"
                                width={100}
                                layout="constrained"
                                placeholder="blurred"
                                formats={["auto", "webp"]}
                                className="flex-none"
                            />
                            <div>
                                <h4 className="mt-0">Aleid van den Brink</h4>
                                <span className="italic">Chair of the GNWS Foundation in the Hague, the Netherlands and First Vice-president of GREVIO (expert group for the monitoring of the Istanbul Convention of the Council of Europe) and GNWS Board member</span>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </section>

        <section>
            <div className="container px-4 md:px-6">

            </div>
        </section>
    </>
  )
}

export default Invitation

export function Head() {
    const { title } = useSiteMetadata();
    return (
      <>
        <title>{`Invitation - ${title}`}</title>
        <meta name="description" content="Join us at the 5th World Conference of Women's Shelters 2025. Participate in a global gathering focused on supporting women's shelters and advocacy." />
        <meta name="keywords" content="5WCWS, WCWS, Women's Shelters, World Conference, 2025, invitation, register, event participation, global gathering, women's advocacy, conference invitation" />
      </>
    )
  }
